"use client";

import { Suspense } from "react";
import { useTranslations } from "@/i18n/client";
import { countries, useGeo } from "@/i18n/routing";
import styles from "./GeoSelector.module.css";

const UnsuspendedGeoStatus = () => {
	const t = useTranslations();
	const { country, language } = useGeo();
	const realCountry = countries.find((c) => c.country === country);

	return (
		<span className={styles.geoStatus}>
			{t(`languages.${language}`)} / ({realCountry?.currency})
		</span>
	);
};

export const GeoStatus: typeof UnsuspendedGeoStatus = () => {
	return (
		<Suspense>
			<UnsuspendedGeoStatus />
		</Suspense>
	);
};
